import { render, staticRenderFns } from "./SaturdayWorkingHours.vue?vue&type=template&id=021d5d08&scoped=true"
import script from "./SaturdayWorkingHours.vue?vue&type=script&lang=js"
export * from "./SaturdayWorkingHours.vue?vue&type=script&lang=js"
import style0 from "./SaturdayWorkingHours.vue?vue&type=style&index=0&id=021d5d08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021d5d08",
  null
  
)

export default component.exports